export const TOTALS_CONFIG = {
    dimensions: [],
    metrics: [
        'rejected_tracker_installs',
        'suspicious_tracker_installs',
        'protected_tracker_installs',
        'est_fraud_saved_cost',
    ],
    discrepancy_metrics: [],
};

export const NETWORK_SUMMARY_CONFIG = {
    dimensions: ['source'],
    metrics: [
        'rejected_tracker_installs',
        'rejected_tracker_installs_rate',
        'suspicious_tracker_installs',
        'suspicious_tracker_installs_rate',
        'est_fraud_saved_cost',
    ],
    discrepancy_metrics: ['tracker_clicks', 'tracker_installs'],
};

export const REJECTION_METHODS_CONFIG = {
    dimensions: ['fps_rejection_reason'],
    metrics: ['est_fraud_saved_cost', 'rejected_tracker_installs', 'rejected_tracker_installs_rate'],
    discrepancy_metrics: [],
};

export const TOTALS_METRIC_DISPLAY_NAMES = {
    rejected_tracker_installs: 'Rejected Installs',
    suspicious_tracker_installs: 'Suspicious Installs',
    protected_tracker_installs: 'Protected Installs',
    est_fraud_saved_cost: 'Est. Fraud Saved Cost',
};

export const TOTALS_METRIC_TYPES = {
    rejected_tracker_installs: 'number',
    suspicious_tracker_installs: 'number',
    protected_tracker_installs: 'number',
    est_fraud_saved_cost: 'currency',
};

export const TOTALS_METRIC_COLORS = {
    rejected_tracker_installs: '#ef4444',
    suspicious_tracker_installs: '#f59e0b',
    protected_tracker_installs: '#22c55e',
    est_fraud_saved_cost: '#3b82f6',
};

// NETWORK_CHART_CONFIG intentionally omits chart: true and is_dashboard: true.
// Using plain UI_REPORTING (is_default: true, no chart flag) with a dynamic time_breakdown
// avoids the UI_CHART / UI_DASHBOARD confusion that caused backend errors.
// time_breakdown is injected dynamically by useNetworkChartData (defaults to 'day').
export const NETWORK_CHART_CONFIG = {
    dimensions: ['source'],
    metrics: [
        'rejected_tracker_installs',
        'rejected_tracker_installs_rate',
        'suspicious_tracker_installs',
        'suspicious_tracker_installs_rate',
        'est_fraud_saved_cost',
    ],
    discrepancy_metrics: ['tracker_clicks', 'tracker_installs'],
};

export const NETWORK_CHART_METRICS = [
    { name: 'tracker_clicks', display_name: 'Tracker Clicks', format: { type: 'number', precision: 0 } },
    { name: 'tracker_installs', display_name: 'Tracker Installs', format: { type: 'number', precision: 0 } },
    { name: 'rejected_tracker_installs', display_name: 'Rejected Installs', format: { type: 'number', precision: 0 } },
    {
        name: 'rejected_tracker_installs_rate',
        display_name: 'Rejected Rate',
        format: { type: 'percentage', precision: 1 },
    },
    {
        name: 'suspicious_tracker_installs',
        display_name: 'Suspicious Installs',
        format: { type: 'number', precision: 0 },
    },
    {
        name: 'suspicious_tracker_installs_rate',
        display_name: 'Suspicious Rate',
        format: { type: 'percentage', precision: 1 },
    },
    { name: 'est_fraud_saved_cost', display_name: 'Est. Saved Cost', format: { type: 'currency', precision: 0 } },
];

export const NETWORK_SUMMARY_COLUMNS = [
    { key: 'source', label: 'Network', type: 'dimension' },
    { key: 'tracker_clicks', label: 'Tracker Clicks', type: 'number' },
    { key: 'tracker_installs', label: 'Tracker Installs', type: 'number' },
    { key: 'rejected_tracker_installs', label: 'Rejected Installs', type: 'number' },
    { key: 'rejected_tracker_installs_rate', label: 'Rejected Rate', type: 'percentage' },
    { key: 'suspicious_tracker_installs', label: 'Suspicious Installs', type: 'number' },
    { key: 'suspicious_tracker_installs_rate', label: 'Suspicious Rate', type: 'percentage' },
    { key: 'est_fraud_saved_cost', label: 'Est. Saved Cost', type: 'currency' },
];

export const REJECTION_METHODS_COLUMNS = [
    { key: 'fps_rejection_reason', label: 'Rejection Method', type: 'dimension' },
    { key: 'est_fraud_saved_cost', label: 'Est. Saved Cost', type: 'currency' },
    { key: 'rejected_tracker_installs', label: 'Rejected Installs', type: 'number' },
    { key: 'rejected_tracker_installs_rate', label: 'Rejected Rate', type: 'percentage' },
];
